import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { scroll } from "../../../../components/utils/utils";
import { Col, Row } from "antd";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import NotesCollapse from "./NotesCollapse";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
// import AddRegistrationRequest from "./AddRegistrationRequest";

import CustomConfigProvider from "../../ProfileHeader";
import {
  getSchoolObservations,
  getSchoolProfileDetails,
} from "../../../../apis/actions/school.actions";
import AddNote from "./NoteRequestModal";
const NotesPage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  const { data: observations, loading } = useSelector(
    (state: RootState) => state?.school?.observations
  );
  const { data: schoolProfileDetails } = useSelector(
    (state: RootState) => state?.school?.schoolProfileDetails
  );

  useEffect(() => {
    dispatch(getSchoolObservations());
    dispatch(getSchoolProfileDetails());
  }, [dispatch]);

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  const itemPerPage = 8;

  return (
    <>
      <CustomConfigProvider
        title="قائمة الملاحظات"
        withdateFilter={false}
      ></CustomConfigProvider>

      <Row
        justify={"space-between"}
        className="takaful--request-col-space"
        style={{ marginBottom: "2rem" }}
      >
        <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
          <PrimaryButton
            onClick={() => setIsModalVisible(true)}
            title="إضافة ملاحظة"
            className="takaful--add-request-btn"
          />
        </Col>
        <Col xxl={20} xl={20} lg={20} md={20} sm={24} xs={24}></Col>
      </Row>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : observations?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا يوجد طلبات
        </p>
      ) : (
        <>
          <Row gutter={[16, 48]} justify={"space-around"} ref={currentRef}>
            <NotesCollapse
              notes={observations?.slice(
                (currentPage - 1) * itemPerPage,
                (currentPage - 1) * itemPerPage + itemPerPage
              )}
            />
          </Row>
          <div className="takaful--pagination-container">
            {observations && observations?.length > itemPerPage && (
              <PaginationComponent
                active={currentPage}
                total={observations?.length}
                itemPerPage={itemPerPage}
                scroll={() => scroll(currentRef)}
                setActive={(nb) => updateActive(nb)}
              />
            )}
          </div>
        </>
      )}

      <AddNote
        students={schoolProfileDetails?.student_ids}
        setIsModalVisible={setIsModalVisible}
        isModalVisible={isModalVisible}
      />
    </>
  );
};

export default NotesPage;
